import React, { PropsWithChildren } from 'react';

import { Draggable } from 'react-beautiful-dnd';

import { IListItem } from '../../../Utils/IListItem';
import { DraggableItemStyled } from '../DraggableItemStyled';
import EmptyList from '../../../Components/EmptyList/EmptyList';
import { InnerListStyled } from '../../../Components/InnerList.styles';
import { IListProps } from '../../../Utils/IListProps';

type IProps<T extends IListItem> = Pick<
  IListProps<T>,
  | 'context'
  | 'customFilter'
  | 'customSort'
  | 'filters'
  | 'itemHeight'
  | 'items'
  | 'listHeight'
  | 'renderItem'
  | 'sorting'
> & { selected: number };

const InnerList = <T extends IListItem>(props: PropsWithChildren<IProps<T>>) => {
  const {
    customSort,
    sorting,
    itemHeight,
    renderItem: Item,
    context,
    listHeight,
    items,
    customFilter,
    filters,
    selected
  } = props;

  const sortItems = (selectedItem: number) => (a: T, b: T): number =>
    customSort ? customSort(a, b) : sorting ? sorting[selectedItem].callback(a, b) : 0;

  const renderItems = items
    .filter(item => {
      const newCustomFilter = customFilter ? customFilter(item) : true;
      const newLocalFilter = filters ? filters[selected].callback(item) : true;

      return newCustomFilter && newLocalFilter;
    })
    .sort(sortItems(selected));

  return (
    <InnerListStyled className="list-body" listHeight={listHeight}>
      {renderItems.length > 0 ? (
        <>
          {renderItems.map((item, index) => (
            <Draggable key={item.id} draggableId={String(item.id)} index={index}>
              {(provided2: any, snapshot2: any) => (
                <DraggableItemStyled
                  isDragging={snapshot2.isDragging}
                  draggableStyle={provided2.draggableProps.draggableStyle}
                  itemHeight={itemHeight}
                  key={`list-item-${item.id}`}
                  ref={provided2.innerRef}
                  {...provided2.draggableProps}
                  {...provided2.dragHandleProps}
                >
                  <Item item={item} context={{ ...context, isDragging: snapshot2.isDragging }} />
                </DraggableItemStyled>
              )}
            </Draggable>
          ))}
        </>
      ) : (
        <EmptyList itemHeight={itemHeight} />
      )}
    </InnerListStyled>
  );
};

export default InnerList;
